export default __webpack_public_path__ + "5fd556bcc21b1fdfefd7945d29f5bc66.png";